import Vue from 'vue';
import { PromotionStyle } from '../Products/Promotion';
import aboveContent from './AboveContent';
import belowContent from './BelowContent';
import SmartSuggestBlocks from '../SmartSuggestBlocks/SmartSuggestBlocks';
import productsContainer from '../Products/ProductsContainer';
import showAllResults, { ShowAllResultsPositions } from '../ShowAllResults/ShowAllResults';
import VisibilityService from '../../services/VisibilityService';
import { SmartSuggestV4 } from '../../../../declarations/request';
import { LandingPageMatchTypes } from '../SmartSuggestBlocks/Landingpage';

const content = Vue.component('fl-content', {
    template: `
    <div class="fl-as-visible" :style="{top: topPosition + 'px', left: leftPosition + 'px'}">
    <fl-above-content />
    <smart-suggest-landingpage
        v-if="onlyShowLandingPage"
        class="fl-as-fully-matching-landingpage fl-as-content"
        :landingpage="fullyMatchingLandingPage"
    />
    <template v-else>
      <fl-promotion v-if="shouldContainFullPromotion" :promotion="promotion" />
      <div class="fl-as-content fl-w-100">
        <div class="fl-pure-sm-1-3 fl-pure-md-1-3 fl-pure-lg-1-3 fl-pure-xl-1-4 fl-as-smart-suggest-blocks">
          <smart-suggest-blocks />
        </div>
        <div class="fl-separate-line"></div>
        <div class="fl-pure-sm-2-3 fl-pure-md-2-3 fl-pure-lg-2-3 fl-pure-xl-3-4 fl-as-products-container">
          <div v-on:click="closeModal" class="fl-closing-btn"></div>
          <fl-products-container class="fl-as-products">
            <template v-slot:showAllResults v-if="showAllResultForProduct">
              <fl-show-all-results />
            </template>
          </fl-products-container>
        </div>
      </div>
      <fl-show-all-results v-if="showAllResultForFull" />
    </template>
    <fl-below-content />
    </div>
  `,
    components: {
        AboveContent: aboveContent,
        BelowContent: belowContent,
        SmartSuggestBlocks,
        ProductsContainer: productsContainer,
        ShowAllResults: showAllResults,
    },
    data(): Record<string, any> {
        return {
            currentInput: null as string,
            selfRect: null as DOMRect,
            searchInputRect: {} as DOMRect,
            fullyMatchingLandingPage: null as string,
            totalResults: null as number,
            promotion: null,
        };
    },
    inject: ['config', 'HandleShopInteractionService', 'requestService'],
    mounted(): void {
        this.HandleShopInteractionService.onInputTriggered((input: HTMLInputElement) => {
            this.$data.currentInput = input;
            this.$data.searchInputRect = input.getBoundingClientRect();
        });

        this.requestService.onResultChange((result: SmartSuggestV4.Response) => {
            this.fullyMatchingLandingPage = result?.landingpage?.matchType === LandingPageMatchTypes.full ? result.landingpage : null;
            this.totalResults = result?.totalResults;
            this.$data.promotion = result?.promotion;
        });

        this.$data.selfRect = this.$el.getBoundingClientRect();
    },
    methods: {
        closeModal(): void {
            VisibilityService.hide();
        },
    },
    computed: {
        onlyShowLandingPage(): boolean {
            return (
                this.fullyMatchingLandingPage &&
                (this.config.assistedSuggest.config.hideProductsOnMatchingLandingPage || this.totalResults === 0)
            );
        },
        showAllResultForProduct(): boolean {
            return this.config.assistedSuggest.config.resultButtonPosition === ShowAllResultsPositions.product;
        },
        showAllResultForFull(): boolean {
            return this.config.assistedSuggest.config.resultButtonPosition === ShowAllResultsPositions.full;
        },
        shouldContainFullPromotion(): boolean {
            return this.config.assistedSuggest.config.promotionStyle === PromotionStyle.FULL;
        },
        topPosition(): number {
            /**
             * +----+-------------------+----+---------+ +
             * |    |  Input            |    |         | |
             * |    |                   |    | Top     | |
             * | +--+-------------------+--+ v         | |
             * | |    Assisted suggest     |           | |
             * | |                         |           | |
             * | +-------------------------+           | |
             * |                                       | |
             * +---------------------------------------+ v
             */

            const inputSize = this.$data.searchInputRect.top + this.$data.searchInputRect.height;

            return this.HandleShopInteractionService.calculateTopPositionFromPositionContext(inputSize);
        },
        leftPosition(): number {
            /**
             * +---------------+---------------------+----------------+
             * |               |      SEARCH         |                |
             * |               +---------------------+                |
             * |               +----------------------------------+   |
             * +-------------->+              OnLeft              |   |
             * |               +----------------------------------+   |
             * |          +-------------------------------+           |
             * +--------->+           OnCenter            |           |
             * |          +-------------------------------+           |
             * |   +----------------------------------+               |
             * +-->+             OnRight              |               |
             * |   +----------------------------------+               |
             * |                                                      |
             * +------------------------------------------------------+
             */
            /* eslint-disable no-magic-numbers */
            if (!this.$data.currentInput) {
                return 0;
            }
            const input = this.$data.searchInputRect as DOMRect;
            const self = this.$data.selfRect as DOMRect;

            const onCenter = input.left - (self.width - input.width) / 2;
            const onRight = input.right - self.width;
            const onLeft = input.left;

            const chooseLimit = window.innerWidth * 0.1;

            if (onCenter < chooseLimit) {
                return onLeft;
            } else if (onCenter + self.width > window.innerWidth - chooseLimit) {
                return onRight;
            }

            return onCenter;
            /* eslint-enable no-magic-numbers */
        },
    },
});

export default content;
